import { ValueOf } from 'next/dist/shared/lib/constants';
import React from 'react';
import { formattedJackpotBoostCost } from 'utils/common';
import { EntryMethod } from '../EntryMethod';

interface IDescription {
  entryMethod: ValueOf<typeof EntryMethod>;
  boostCostPerEntry: number;
  style?: React.CSSProperties;
}

export const Description = ({
  entryMethod,
  boostCostPerEntry,
  style,
}: IDescription) => {
  const formattedBoostCostPerEntry = formattedJackpotBoostCost(
    boostCostPerEntry * 100
  );

  return entryMethod === EntryMethod.LiteSubscription ? (
    <p style={{ ...style }}>
      10x your jackpot value from <strong>£10K to £100K</strong> for{' '}
      {formattedBoostCostPerEntry} per entry
    </p>
  ) : (
    <p style={{ ...style }}>
      Quadruple your jackpot value from <strong>£25K to £100K</strong> for{' '}
      {formattedBoostCostPerEntry} per entry
    </p>
  );
};
